const session = window.sessionStorage
const local = window.localStorage
const redirectPath = 'redirectKey'
// 保存状态
import { Notification } from 'element-ui'
// 所有的code值
import statusMap from './statusInfo'
import httpWhiteList from './httpWhiteList'

export default {
  SET_REDIRECT_PATH(path) {
    if (this.GET_REDIRECT_PATH() === 'loginOut') path = ''
    sessionStorage.clear()
    return session.setItem(redirectPath, path)
  },
  GET_REDIRECT_PATH() {
    return session.getItem(redirectPath) || '/'
  },

  localGetKey(key) {
    return local.getItem(key)
  },

  localSetKey(key, val) {
    return local.setItem(key, val)
  },

  localDelKey(key) {
    return local.removeItem(key)
  },

  getKey(key) {
    return session.getItem(key)
  },
  setKey(key, val) {
    return session.setItem(key, val)
  },
  delPage(key) {
    return session.removeItem(key)
  },

  goDetail(me, pushObj, page, key) {
    this.setKey(key, JSON.stringify(page))
    if (pushObj) {
      me.$router.push(pushObj)
    }
  },
  goIndex(key, obj) {
    const pageData = JSON.parse(this.getKey(key))
    if (!pageData) return obj
    return Object.assign(obj, pageData)
  },
  /**
   * 计算过期时间
   * @param {*} time 服务端返回的过期时间
   * @return {time} 过期时间减去15分钟提前获取防止过期重新登录
   */
  tockenTime(time) {
    return time - 1 * 60 * 15 * 1000
  },
  getMsg(code, msg) {
    code = parseInt(code)
    if (code === 9701) {
      return msg || '操作失败'
    }
    return statusMap[code] || msg || statusMap[1]
  },
  notifyErrMsg(code, msg) {
    Notification({
      title: '警告',
      message: this.getMsg(code, msg),
      type: 'error',
      duration: 2000
    })
  },
  notifySuccess(message) {
    this.notify(message, 'success', '成功')
  },
  notify(message, type, title) {
    Notification({
      title,
      message,
      type,
      duration: 2000
    })
  },
  pricetoFixed(price) {
    // 小数点后两位
    if (price || price === 0) {
      return (parseInt(price) / 100).toFixed(2)
    } else {
      return '——'
    }
  }
}
// 下拉框数据
export function optionSet(list, uselist, optval = 'code', optlab = 'name') {
  // 兼容功能
  let reslist = []
  if (list.result) {
    reslist = list.result
  } else {
    reslist = list
  }
  for (let i = 0; i < reslist.length; i++) {
    const newdata = {
      value: reslist[i][optval],
      lable: reslist[i][optlab]
    }
    uselist.push(newdata)
  }
  return uselist
}

export function normalizePrice(price) {
  // 价格是分
  return Math.round((parseInt(price) / 100) * 100) / 100
}

// 防抖
export function _debounce(fn, delay) {
  delay = delay || 200
  let timer
  return function() {
    const that = this
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      fn.apply(that, args)
    }, delay)
  }
}
// 节流
export function _throttle(fn, interval) {
  let last, timer
  interval = interval || 200
  return function() {
    const that = this
    const args = arguments
    const now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        last = now
        fn.apply(that, args)
      }, interval)
    } else {
      last = now
      fn.apply(that, args)
    }
  }
}

export function formatNum(str) {
  let newStr = ''
  let count = 0

  if (str.indexOf('.') === -1) {
    for (let i = str.length - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        newStr = str.charAt(i) + ',' + newStr
      } else {
        newStr = str.charAt(i) + newStr
      }
      count++
    }
    str = newStr + '.00' // 自动补小数点后两位
    return str
  } else {
    for (let i = str.indexOf('.') - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        newStr = str.charAt(i) + ',' + newStr
      } else {
        newStr = str.charAt(i) + newStr // 逐个字符相接起来
      }
      count++
    }
    str = newStr + (str + '00').substr((str + '00').indexOf('.'), 3)
    return str
  }
}
/**
 * 判断是否为http白名单请求以及code
 * @return {boolean} true:在白名单中 false:不在
 */
export function isWhiteList(conf, code) {
  // 数据按照httpType分组
  const whiteList = httpWhiteList[conf.method]
  for (let index = 0; index < whiteList.length; index++) {
    const item = whiteList[index]
    // 是否在白名单中
    if (item.rUrl.test(conf.url)) {
      return item.status.indexOf(code) !== -1
    }
  }
  return false
}

/**
 * 导出文件时使用
 * @param {*} data 需要下载的数据
 * @param {*} type 数据类型默认.xls
 */
export function downFile(data, type = '.xlsx', name = `${new Date().getTime()}`) {
  const url = window.URL.createObjectURL(new Blob([data]))
  const a = document.createElement('a')
  a.style.display = 'none'
  a.href = url
  a.setAttribute('download', `${name}${type}`)
  document.body.appendChild(a)
  a.click() // 执行下载
  window.URL.revokeObjectURL(a.href)
  document.body.removeChild(a)
}

/**
 * 根据传入的属性结构，和id返回id的直系父级id列表
 * @param {*} selectId 选择的id
 * @param {*} tree 属性结构
 * @param {*} self 返回值是否包含自己
 * @return []
 */
export function getTreeId(selectId, tree, self = true) {
  const unfoldTree = [] //  展开属性结构的数据
  let tierList = []

  // 每次展开（当局部刷新之后关心这个）
  const recursionChild = list => {
    if (list && list.length) {
      for (let index = 0; index < list.length; index++) {
        const item = list[index]
        unfoldTree.push(item)
        if (item.children && item.children.length) {
          recursionChild(item.children)
        }
      }
    }
  }
  recursionChild(tree)

  const getSelectTree = id => {
    if (unfoldTree && unfoldTree.length) {
      for (let index = 0; index < unfoldTree.length; index++) {
        const element = unfoldTree[index]
        if (element.id === id) {
          if (element.parentId !== 0) {
            getSelectTree(element.parentId)
          }
          tierList.push(element.id)
          break
        }
      }
    }
  }
  getSelectTree(selectId)
  if (self === false) {
    tierList.splice(tierList.length - 1, 1)
  }
  if (tierList.length === 0) {
    tierList = [0]
  }
  return tierList
}

/**
 * 根据传入的属性结构，和id返回id的直系父级数据信息
 * @param {*} selectId
 * @param {*} tree
 * @param {*} self
 * @param {*} key
 * @returns
 */
export function getTreeInfo(selectId, tree, self = true, key = 'name') {
  const unfoldTree = [] //  展开属性结构的数据
  let tierList = []

  // 每次展开（当局部刷新之后关心这个）
  const recursionChild = list => {
    if (list && list.length) {
      for (let index = 0; index < list.length; index++) {
        const item = list[index]
        unfoldTree.push(item)
        if (item.children && item.children.length) {
          recursionChild(item.children)
        }
      }
    }
  }
  recursionChild(tree)

  const getSelectTree = id => {
    if (unfoldTree && unfoldTree.length) {
      for (let index = 0; index < unfoldTree.length; index++) {
        const element = unfoldTree[index]
        if (element.id === id) {
          if (element.parentId !== 0) {
            getSelectTree(element.parentId)
          }
          tierList.push(element[key])
          break
        }
      }
    }
  }
  getSelectTree(selectId)
  if (self === false) {
    tierList.splice(tierList.length - 1, 1)
  }
  if (tierList.length === 0) {
    tierList = []
  }
  return tierList
}

/**
 * 根据url更换icon
 * @param {} url
 */
export function setTitleIcon(url) {
  const link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = url
  document.getElementsByTagName('head')[0].appendChild(link)
}

/**
 * 颜色转换 hsl转为rgb
 * @param h
 * @param s
 * @param l
 * @returns {string}
 */
export function hslToRgb(h, s, l) {
  var r, g, b
  if (s === 0) {
    r = g = b = l // achromatic
  } else if (l >= 1) {
    r = g = b = 1 // achromatic
  } else if (l <= 0) {
    r = g = b = 0 // black
  } else {
    var hue2rgb = function hue2rgb(p, q, t) {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < (1 / 6)) return p + (q - p) * 6 * t
      if (t < (1 / 2)) return q
      if (t < (2 / 3)) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }

    var q = l < 0.5 ? l * (1 + s) : l + s - l * s
    var p = 2 * l - q
    r = hue2rgb(p, q, h + (1 / 3))
    g = hue2rgb(p, q, h)
    b = hue2rgb(p, q, h - (1 / 3))
  }
  return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) }
}

/**
 * 颜色转换 rgb转为hsl
 * @param r
 * @param g
 * @param b
 * @returns {{h: number, s: number, l: number}}
 */
export function rgbToHsl(r, g, b) {
  r /= 255; g /= 255; b /= 255
  var max = Math.max(r, g, b); var min = Math.min(r, g, b)
  var h; var s; var l = (max + min) / 2

  if (max === min) {
    h = s = 0 // achromatic
  } else {
    var d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break
      case g: h = (b - r) / d + 2; break
      case b: h = (r - g) / d + 4; break
    }
    h /= 6
  }

  return { h: h, s: s, l: l }
}
